function getURLParameter(sParam) {
  var sPageURL = window.location.search.substring(1);
  var sURLVariables = sPageURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }
}

function toTree(arr) {
  const obj = {};
  const res = [];
  for (let i = 0; i < arr.length; i++) {
    for (let j = 0; j < arr[i].length; j++) {
      let item = arr[i][j];
      if (!obj[item]) {
        obj[item] = {
          name: item,
          child: [],
        };
      }
      if (j > 0) {
        const parent = obj[arr[i][j - 1]];
        if (parent) {
          if (parent.child.indexOf(obj[item]) < 0) {
            parent.child.push(obj[item]);
          }
        }
      } else {
        if (res.indexOf(obj[item]) < 0) {
          res.push(obj[item]);
        }
      }
    }
  }
  return res;
}






export {
  getURLParameter,toTree
}
